<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Navbar',
})
</script>
<template>
  <div class="Navbar">
    <div class="nav-bar-wrap">
      <div
        class="back-icon"
        :class="{ dark: mode && mode === 'dark' }"
        @click="closeView"
      >
      </div>
      <div class="nav-bar-title" :class="{ dark: mode && mode === 'dark' }">
        {{ title }}
      </div>
      <div class="nav-bar-right">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts" name="Navbar">
import { statusBarHeight } from '@/utils/constance'
import { toVw } from '@/utils/index'
import { setWhiteStatusBar } from '@/utils/native'
import { closeWebview } from '@/utils/native'
import { computed, onMounted } from 'vue'

const props = defineProps<
  { title: string; mode?: 'light' | 'dark'; back?: () => void }
>()

const status_bar_height = computed(() => `${toVw(statusBarHeight)}vw`)

const closeView = () => {
  if (props.back) {
    props.back()
  } else {
    closeWebview()
  }
}
onMounted(() => {
  if (props.mode === 'light') {
    setWhiteStatusBar()
  }
})
</script>

<style scoped lang="scss">
[dir="rtl"] .back-icon {
  transform: rotate(180deg);
}

.Navbar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  flex-shrink: 0;
  width: 100%;
  height: 153px;
  padding-top: v-bind(status_bar_height);

  .nav-bar-wrap {
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
    opacity: 1;

    .back-icon {
      flex-shrink: 0;
      width: 48px;
      height: 48px;
      margin: 0 28px;

      @include background-image-mixin("./arrow-back.svg", center, 100%);

      // &.dark {
      //   background-image: url("./arrow-back-dark.webp");
      // }
    }

    .nav-bar-title {
      flex: 1;
      font-weight: 400;
      font-size: 36px;
      color: #ffffff;
      line-height: 50px;
      text-align: center;

      &.dark {
        color: #262626;
      }
    }

    .nav-bar-right {
      position: relative;
      flex-shrink: 0;
      width: 50px;
      height: 50px;
      margin: 0 28px;
    }
  }
}
</style>
